<div *ngIf="ts" class="datiSommario">
    <div class="row titolosommario p-2">
        <div class="col-12 text-center">
            <h3>Mercato {{ts.mercato}}</h3>
            <h6> (spread {{ts.spread | number: '1.1-1'}})</h6>
        </div>
    </div>
    <div class="row">
        <div class="col-6"></div>
        <div class="col-2 text-end">
            Buy
        </div>
        <div class="col-2 text-end">
            Sell
        </div>
        <div class="col-2 text-end">
            Totale
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Numero Operazioni
        </div>
        <div class="col-2 text-end">
            {{ts.numopbuy}}
        </div>
        <div class="col-2 text-end">
            {{ts.numopsell}}
        </div>
        <div class="col-2 text-end">
            {{ts.numop}}
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Numero Operazioni Positive
        </div>

        <div class="col-2 text-end">
            {{ts.numopbuypos}}
        </div>
        <div class="col-2 text-end">
            {{ts.numopsellpos}}
        </div>
        <div class="col-2 text-end">
            {{ts.numoppos}}
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Percentuale Operazioni Positive
        </div>
        <div class="col-2 text-end">
            {{ts.percposbuy| number: '1.2-2'}}%
        </div>
        <div class="col-2 text-end">
            {{ts.percpossell| number: '1.2-2'}}%
        </div>
        <div class="col-2 text-end">
            {{ts.percpos| number: '1.2-2'}}%
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Punti Totali
        </div>
        <div class="col-2 text-end">
            {{ts.puntitotbuy| number: '1.1-1'}}
        </div>
        <div class="col-2 text-end">
            {{ts.puntitotsell| number: '1.1-1'}}
        </div>
        <div class="col-2 text-end">
            {{ts.puntitot| number: '1.1-1'}}
        </div>

    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Punti per Operazione
        </div>
        <div class="col-2 text-end">
            {{ts.puntiopbuy| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.puntiopsell| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.puntiop| number: '1.2-4'}}
        </div>
    </div>

    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Max Profit
        </div>
        <div class="col-2 text-end">
            {{ts.maxprofitbuy| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.maxprofitsell| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.maxprofit| number: '1.2-4'}}
        </div>
    </div>

    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Max Loss
        </div>
        <div class="col-2 text-end">
            {{ts.maxlossbuy| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.maxlosssell| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.maxloss| number: '1.2-4'}}
        </div>
    </div>

    <div class="row" style="padding: 5px;">
        <div class="col-6">
            RAWAL
        </div>
        <div class="col-2 text-end">
            {{ts.rawalbuy| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.rawalsell| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.rawal| number: '1.2-4'}}
        </div>
    </div>

    <div class="row" style="padding: 5px;">
        <div class="col-6">
            Kelly
        </div>
        <div class="col-2 text-end">
            {{ts.kellybuy| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.kellysell| number: '1.2-4'}}
        </div>
        <div class="col-2 text-end">
            {{ts.kelly| number: '1.2-4'}}
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-10">
            MaxDD (punti)
        </div>
        <div class="col-2 text-end">
            {{ts.maxDD | number: '1.2-4'}}
        </div>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-10">
            RRR
        </div>
        <div class="col-2 text-end">
            {{(ts.puntitot/ ts.maxDD) | number: '1.2-2'}}
        </div>
    </div>
</div>